export class EntityCredentialSpecialty {
  constructor(
    public id: string,
    public credentialSpecialtyDefinitionId: string,
    public entityId: string,
    public entityName: string,
    public entityCredentialId: string,
    public entityCredentialApplicationId: string,
    public credentialName: string,
    public name: string,
    public comments: string,
    public credentialDefinitionId: string
  ) {}

  static parse(obj: Partial<EntityCredentialSpecialty>): EntityCredentialSpecialty {
    if (obj == null) return null;
    return new EntityCredentialSpecialty(
      obj.id,
      obj.credentialSpecialtyDefinitionId,
      obj.entityId,
      obj.entityName,
      obj.entityCredentialId,
      obj.entityCredentialApplicationId,
      obj.credentialName,
      obj.name,
      obj.comments,
      obj.credentialDefinitionId
    );
  }
}
